import { gql } from '@apollo/client';

export const GET_NOTIFICATION_SETTINGS = gql`
  query GetNotificationSettings {
    notificationSettings {
      id
      role
      notificationType
      emailEnabled
      smsEnabled
    }
  }
`;

export const GET_SYSTEM_NOTIFICATION_CONFIG = gql`
  query GetSystemNotificationConfig {
    systemNotificationConfig {
      id
      testModeEnabled
      testEmail
      testPhoneNumber
      callCenterNotificationEmail
    }
  }
`;

export const GET_NOTIFICATION_PREVIEW = gql`
  query GetNotificationPreview($notificationType: NotificationType!) {
    notificationPreview(notificationType: $notificationType) {
      notificationType
      emailSubject
      emailText
      emailHtml
      smsText
    }
  }
`;

export const GET_GUEST_WORK_ORDER_NOTIFICATION_PREVIEW = gql`
  query GetGuestWorkOrderNotificationPreview($event: String!) {
    guestWorkOrderNotificationPreview(event: $event) {
      event
      emailSubject
      emailText
      emailHtml
      smsText
    }
  }
`;

export const UPDATE_NOTIFICATION_SETTING = gql`
  mutation UpdateNotificationSetting($id: ID!, $input: UpdateNotificationSettingInput!) {
    updateNotificationSetting(id: $id, input: $input) {
      id
      role
      notificationType
      emailEnabled
      smsEnabled
    }
  }
`;

export const UPDATE_SYSTEM_NOTIFICATION_CONFIG = gql`
  mutation UpdateSystemNotificationConfig($input: UpdateSystemNotificationConfigInput!) {
    updateSystemNotificationConfig(input: $input) {
      id
      testModeEnabled
      testEmail
      testPhoneNumber
      callCenterNotificationEmail
    }
  }
`;

export const SEND_TEST_NOTIFICATION = gql`
  mutation SendTestNotification($email: String, $phoneNumber: String) {
    sendTestNotification(email: $email, phoneNumber: $phoneNumber)
  }
`;

export const SEND_TEST_NOTIFICATION_BY_TYPE = gql`
  mutation SendTestNotificationByType($notificationType: String!, $email: String) {
    sendTestNotificationByType(notificationType: $notificationType, email: $email)
  }
`;

export const INITIALIZE_DEFAULT_NOTIFICATION_SETTINGS = gql`
  mutation InitializeDefaultNotificationSettings {
    initializeDefaultNotificationSettings
  }
`;

// User-level notification preferences
export const UPDATE_USER_NOTIFICATION_PREFERENCES = gql`
  mutation UpdateNotificationPreferences($emailEnabled: Boolean, $smsEnabled: Boolean) {
    updateNotificationPreferences(emailEnabled: $emailEnabled, smsEnabled: $smsEnabled) {
      id
      emailNotifications
      smsNotifications
    }
  }
`;

export const GET_MY_NOTIFICATION_PREFERENCES = gql`
  query GetMyNotificationPreferences {
    myNotificationPreferences {
      id
      notificationType
      emailEnabled
      smsEnabled
      roleEmailEnabled
      roleSmsEnabled
    }
  }
`;

export const GET_USER_NOTIFICATION_PREFERENCES = gql`
  query GetUserNotificationPreferences($userId: Int!) {
    userNotificationPreferences(userId: $userId) {
      id
      notificationType
      emailEnabled
      smsEnabled
      roleEmailEnabled
      roleSmsEnabled
    }
  }
`;

export const UPDATE_MY_NOTIFICATION_PREFERENCE = gql`
  mutation UpdateMyNotificationPreference($notificationType: NotificationType!, $emailEnabled: Boolean, $smsEnabled: Boolean) {
    updateMyNotificationPreference(
      notificationType: $notificationType
      emailEnabled: $emailEnabled
      smsEnabled: $smsEnabled
    ) {
      id
      notificationType
      emailEnabled
      smsEnabled
      roleEmailEnabled
      roleSmsEnabled
    }
  }
`;

export const UPDATE_USER_NOTIFICATION_PREFERENCE = gql`
  mutation UpdateUserNotificationPreference(
    $userId: Int!
    $notificationType: NotificationType!
    $emailEnabled: Boolean
    $smsEnabled: Boolean
  ) {
    updateUserNotificationPreference(
      userId: $userId
      notificationType: $notificationType
      emailEnabled: $emailEnabled
      smsEnabled: $smsEnabled
    ) {
      id
      notificationType
      emailEnabled
      smsEnabled
      roleEmailEnabled
      roleSmsEnabled
    }
  }
`;

export const DISABLE_NOTIFICATION_FOR_ALL_USERS = gql`
  mutation DisableNotificationForAllUsers($notificationType: NotificationType!) {
    disableNotificationForAllUsers(notificationType: $notificationType)
  }
`;

export const SEND_JOB_ALERTS_TO_ASSIGNED_USERS = gql`
  mutation SendJobAlertsToAssignedUsers {
    sendJobAlertsToAssignedUsers {
      notifiedUsers
      totalJobs
      userDetails {
        userId
        email
        jobCount
      }
    }
  }
`; 
